
document.addEventListener('DOMContentLoaded', attachBuyOptionEvents);
document.addEventListener('DOMContentLoaded', function(){
    if (window.eventBus) {
        window.eventBus.on('product:modal:ready', () => {
            attachBuyOptionEvents(); 
        });
      }
});

function attachBuyOptionEvents() {
    // VARIANT SELECTORS CLICK EVENTS
    const variantSelectors = document.querySelectorAll('[variant-selector]');
    variantSelectors.forEach(variantSelector => {
        variantSelector.addEventListener('click', () => {
            const variantId = variantSelector.getAttribute('data-variant-id');
            const subscriptionComponent = document.querySelector(`.variant-subscription-options[data-variant-id="${variantId}"]`);
            let subscriptionData = {};
            const subscriptionDataComponent = subscriptionComponent.querySelector('.subscription-custom-selector');
            if (subscriptionDataComponent) {
                subscriptionData = subscriptionDataComponent.dataset;
            }
            const purchaseType = variantSelector.getAttribute('data-purchase-type');
            const price = variantSelector.getAttribute('data-variant-price');
            const comparePrice = variantSelector.getAttribute('data-variant-compare-at-price');
            const subscriptionPrice = subscriptionData.finalPrice;
            const subscriptionComparePrice = subscriptionData.comparePrice;
            let subscriptionId = '';
            if (purchaseType == 'subscription-purchase') {
                subscriptionId = subscriptionComponent.querySelector('.subscription-custom-selector').getAttribute('data-selected-selling-plan-id');
                const purchaseTypeSubscription = document.querySelector('#purchase-type-subscription');
                const oneTimePurchase = document.querySelector(`.variant-selector--variant input#variant-${variantId}-one-time-purchase`);
                if (purchaseTypeSubscription) {
                    purchaseTypeSubscription.checked = true;
                }
                if (oneTimePurchase) {
                    oneTimePurchase.checked = true;
                }
                const subscriptionOptionsComponentAll = document.querySelectorAll('.variant-subscription-options[data-variant-id]');
                subscriptionOptionsComponentAll.forEach(subscriptionOptionComponent => {
                    subscriptionOptionComponent.classList.add('hidden');
                });
                const subscriptionOptions = document.querySelector(`.variant-subscription-options[data-variant-id="${variantId}"]`);
                if (subscriptionOptions) {
                    subscriptionOptions.classList.remove('hidden');
                }
                document.querySelector('.subscription-form--wrapper').classList.remove('one-time-purchase');
                document.querySelector('.subscription-form--wrapper').classList.add('subscription-purchase');
                updateProductUrl(variantId, subscriptionId);
            } else {
                const purchaseTypeOneTime = document.querySelector('#purchase-type-one-time');
                const subscriptionPurchase = document.querySelector(`.variant-selector--variant input#variant-${variantId}-subscription-purchase`);
                if (purchaseTypeOneTime) {
                    purchaseTypeOneTime.checked = true;
                }
                if (subscriptionPurchase) {
                    subscriptionPurchase.checked = true;
                }
                const subscriptionOptionsComponentAll = document.querySelectorAll('.variant-subscription-options[data-variant-id]');
                subscriptionOptionsComponentAll.forEach(subscriptionOptionComponent => {
                    subscriptionOptionComponent.classList.add('hidden');
                });
                const subscriptionOptions = document.querySelector(`.variant-subscription-options[data-variant-id="${variantId}"]`);
                if (subscriptionOptions) {
                    subscriptionOptions.classList.remove('hidden');
                }
                document.querySelector('.subscription-form--wrapper').classList.add('one-time-purchase');
                document.querySelector('.subscription-form--wrapper').classList.remove('subscription-purchase');
                updateProductUrl(variantId, '');
            }
            updateFormData(variantId, subscriptionId);
            updatePrices(price, comparePrice, subscriptionPrice, subscriptionComparePrice);
        });
    });

    // PURCHASE TYPE OPTIONS CLICK EVENTS
    const purchaseTypeOptions = document.querySelectorAll('[purchas-type-option]');
    purchaseTypeOptions.forEach(purchaseTypeOption => {
        purchaseTypeOption.addEventListener('click', () => {
            const purchaseType = purchaseTypeOption.getAttribute('data-type');
            if (purchaseType == 'subscription') {
                const label =  document.querySelector('input[name="variant-option-subscription-purchase"]:checked + label');
                if (label) {
                  label.click();
                } else {
                  document.querySelector('input[name="variant-option-subscription-purchase"]').checked = true;
                  document.querySelector('input[name="variant-option-subscription-purchase"]:checked + label').click()
                }
                const variantId = document.querySelector(`input[name="variant-option-subscription-purchase"]:checked`).value;
                const subscriptionId = document.querySelector(`.variant-subscription-options[data-variant-id="${variantId}"] .subscription-custom-selector`).getAttribute('data-selected-selling-plan-id');
                updateFormData(variantId, subscriptionId);
                updateProductUrl(variantId, subscriptionId);
                document.querySelector('.subscription-form--wrapper').classList.remove('hidden');
                document.querySelector('.subscription-form--wrapper').classList.add('subscription-purchase');
            } else {
                const variantId = document.querySelector(`input[name="variant-option-one-time-purchase"]:checked`).value;
                const subscriptionId = '';
                updateFormData(variantId, subscriptionId);
                updateProductUrl(variantId, subscriptionId);
                document.querySelector('.subscription-form--wrapper').classList.add('one-time-purchase');
                document.querySelector('.subscription-form--wrapper').classList.remove('subscription-purchase');
            }
        });
    });

    // SUBSCRIPTION SELECTOR CLICK EVENTS
    const subscriptionOptions = document.querySelectorAll('.subscription-option');
    subscriptionOptions.forEach(subscriptionOption => {
        subscriptionOption.addEventListener('click', () => {
            document.querySelector('input[name="variant-option-subscription-purchase"]:checked').checked = true;
            const data = subscriptionOption.dataset;
            const price = data.price;
            const comparePrice = data.comparePrice;
            const subscriptionPrice = data.subscriptionFinalPrice;
            const subscriptionComparePrice = data.subscriptionComparePrice;
            const variantId = data.variantId;
            const subscriptionId = data.subscriptionId;
            const subscriptionName = data.subscriptionName;
            const selector = document.querySelector(`.variant-subscription-options[data-variant-id="${variantId}"] .subscription-custom-selector`);
            const wrapper = subscriptionOption.parentElement;
            if (selector) {
                selector.querySelector('.subscription-message-text').textContent = subscriptionName;
                selector.setAttribute('data-selected-selling-plan-id', subscriptionId);
                selector.setAttribute('data-final-price', subscriptionPrice);
                selector.setAttribute('data-compare-price', subscriptionComparePrice);
            }
            wrapper.classList.add('hidden');
            updatePrices(price, comparePrice, subscriptionPrice, subscriptionComparePrice);
            updateFormData(variantId, subscriptionId);
            updateProductUrl(variantId, subscriptionId);
            selector.classList.remove('no-plan-selected');
            document.querySelector('input#purchase-type-subscription').checked = true;
            document.querySelector('.subscription-form--wrapper').classList.remove('hidden');
            document.querySelector('.subscription-form--wrapper').classList.add('subscription-purchase');
        });
    });

    // CUSTOM SELECTOR CLICK EVENTS
    const customSelectors = document.querySelectorAll('.subscription-custom-selector');
    let outsideClickBound = false;

    const findTriggerForContainer = (container) => {
        if (!container) return null;
        let trigger = container.previousElementSibling;
        while (trigger && !(trigger.classList && trigger.classList.contains('subscription-custom-selector'))) {
            trigger = trigger.previousElementSibling;
        }
        if (!trigger) {
            trigger = container.closest('.variant-subscription-options')?.querySelector('.subscription-custom-selector');
        }
        return trigger || null;
    };

    const bindOutsideClickListener = () => {
        if (outsideClickBound) return;
        document.addEventListener('click', (event) => {
            const openContainers = document.querySelectorAll('.subscription-selector-options:not(.hidden)');
            openContainers.forEach((container) => {
                const trigger = findTriggerForContainer(container);
                if (container.contains(event.target) || trigger?.contains(event.target)) {
                    return;
                }
                container.classList.add('hidden');
                trigger?.classList.remove('subscription-selector-open');
            });
        });
        outsideClickBound = true;
    };

    customSelectors.forEach(customSelector => {
        customSelector.addEventListener('click', () => {
            bindOutsideClickListener();

            const variantWrapper = customSelector.closest('.variant-subscription-options');
            if (!variantWrapper) return;

            let optionsContainer = customSelector.nextElementSibling;
            while (optionsContainer && !optionsContainer.classList.contains('subscription-selector-options')) {
                optionsContainer = optionsContainer.nextElementSibling;
            }

            if (!optionsContainer) return;
            let isHidden = false;
            if (optionsContainer.classList.contains('hidden')) {
                isHidden = true;
            }
            variantWrapper.querySelectorAll('.subscription-selector-options').forEach(container => {
                if (container !== optionsContainer) {
                    container.classList.add('hidden');
                    customSelector.classList.remove('subscription-selector-open');
                }
            });
            if (isHidden) {
                console.log('isHidden: ' + isHidden);
                optionsContainer.classList.remove('hidden');
                customSelector.classList.add('subscription-selector-open');
            } else {
              console.log('isHidden: ' + isHidden);
                optionsContainer.classList.add('hidden');
                customSelector.classList.remove('subscription-selector-open');
            }
        });
    });
}

function updateFormData(variantId, subscriptionId) {
    const form = document.querySelector('.subscription-form--data');
    const variantInput = form.querySelector('input[name="id"]');
    const subscriptionInput = form.querySelector('input[name="selling_plan"]');
    if (variantId !== '') {
        variantInput.value = variantId;
    }
    subscriptionInput.value = subscriptionId;

}

function updatePrices(price, comparePrice, subscriptionPrice, subscriptionComparePrice) {
    const priceElement = document.querySelector('[data-one-time-price-label]');
    const comparePriceElement = document.querySelector('[data-one-time-compare-price-label]');
    const subscriptionPriceElement = document.querySelector('[data-subscription-price-label]');
    const subscriptionComparePriceElement = document.querySelector('[data-subscription-compare-price-label]');
    priceElement.textContent = price;
    comparePriceElement.textContent = comparePrice;
    subscriptionPriceElement.textContent = subscriptionPrice;
    subscriptionComparePriceElement.textContent = subscriptionComparePrice;
    // console.log('price: ' + price + ' comparePrice: ' + comparePrice + ' subscriptionPrice: ' + subscriptionPrice + ' subscriptionComparePrice: ' + subscriptionComparePrice);
}


function updateProductUrl(variantId, sellingPlanId) {
    const url = new URL(window.location.href);
    if (variantId) {
      url.searchParams.set('variant', variantId);
    } else {
      url.searchParams.delete('variant');
    }
    if (sellingPlanId) {
      url.searchParams.set('selling_plan', sellingPlanId);
    } else {
      url.searchParams.delete('selling_plan');
    }
    window.history.replaceState({}, '', `${url.pathname}${url.search}`);
  }

  document.addEventListener('click', async (e) => {
    const addButton = e.target.closest('[data-subscription-add]');
    if (!addButton) return; // click not on your add button

    const container = addButton.closest('[data-subscription-form]');
    if (!container) return;

    const dataWrapper = container.querySelector('.subscription-form--data');
    const errorMessage = document.querySelector('[data-subscription-error]');

    const getInputValue = (selector) => {
      const input = dataWrapper.querySelector(selector);
      return input ? input.value : '';
    };

    const getQuantityValue = () => {
      const quantityInput = container.querySelector('#quantity-input');
      const quantity = quantityInput ? quantityInput.value : getInputValue('input[name="quantity"]');
      return quantity && parseInt(quantity, 10) > 0 ? quantity : '1';
    };

    const setLoadingState = (isLoading) => {
      addButton.disabled = isLoading;
      addButton.classList.toggle('is-loading', isLoading);
    };

    const showError = (message) => {
      if (!errorMessage) return;
      errorMessage.textContent = message;
      errorMessage.classList.remove('hidden');
    };

    const resetError = () => {
      if (!errorMessage) return;
      errorMessage.textContent = '';
      errorMessage.classList.add('hidden');
    };


    const variantId = getInputValue('input[name="id"]');
    const sellingPlanId = getInputValue('input[name="selling_plan"]');
    const quantity = getQuantityValue();
    

    if (!variantId) {
      showError('Unable to add this product right now. Please try again.');
      return;
    }

    const purchaseType = document.querySelector('input[name="purchase_type"]:checked').value;
    const planSelected = document.querySelector(`.variant-subscription-options[data-variant-id="${variantId}"] .subscription-custom-selector`);
    console.log('planSelected: ', planSelected);
    if (purchaseType == 'subscription' && planSelected.classList.contains('no-plan-selected')) {
      showError('Please select frequency');
      planSelected.style.borderColor = '#d50032';
      setTimeout(() => {
        planSelected.style.borderColor = 'rgba(0,0,0,.25 )';
      }, 3000);
      return;
    }

    resetError();
    setLoadingState(true);

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    if (sellingPlanId) formData.append('selling_plan', sellingPlanId);
    formData.append('sections', 'cart-drawer');

    const cartAddUrl = (window.routes && window.routes.cart_add_url)
      || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root && `${window.Shopify.routes.root}cart/add.js`)
      || '/cart/add.js';

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      });

      const responseJson = await response.json();
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const message = errorData.description || errorData.message || 'Only one-time purchase is available for B2B orders.';
        showError(message);
        return;
      }

      // if (_learnq) {
      //   _learnq.push(['track', 'Added to Cart', item]);
      // }

      if (window.eventBus) {
        window.eventBus.emit('update:cart:drawer', responseJson);
        window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
        window.eventBus.emit('cart:added', { source: 'subscription-form' });
      }
    } catch (error) {
      console.error('Error adding subscription product to cart:', error);
      showError('There was an issue adding this product to your cart.');
    } finally {
      setLoadingState(false);
    }
  });

  // Delegated handler for quantity selector clicks
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const selector = btn.closest('.quantity-selector');
    if (!selector) return;

    const input = selector.querySelector('input[name="quantity"]');
    if (!input) return;

    const action = btn.dataset.action;
    let value = parseInt(input.value, 10) || 0;
    if (action === 'increase') value++;
    if (action === 'decrease' && value > 1) value--;
    input.value = value;
    input.dispatchEvent(new Event('change')); // trigger change events if needed
  });
  document.addEventListener('click', e => {
    if (e.target.closest('[data-subscription-add]')) {
      console.log('✅ Delegated click detected');
    }
  });